export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  brandLink: "nav-brand-link",
  loginBtn: "nav-login-btn",
  signupBtn: "nav-signup-btn",
  dashboardBtn: "nav-dashboard-btn",
};

export const MARKETING = {
  heroHeadline: "hero-headline",
  heroCta: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  productModule: (key) => `product-module-${key}`,
  pricingCta: (tier) => `pricing-cta-${tier}`,
  requestDemoBtn: "request-demo-btn",
};

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerName: "register-name-input",
  registerRole: "register-role-select",
  registerSubmit: "register-submit-btn",
  quickLogin: (role) => `quick-login-${role}`,
};

export const APP = {
  sidebar: "app-sidebar",
  sidebarLink: (key) => `sidebar-link-${key}`,
  topbar: "app-topbar",
  logoutBtn: "app-logout-btn",
  aiCopilotToggle: "ai-copilot-toggle",
  aiCopilotPanel: "ai-copilot-panel",
  aiCopilotInput: "ai-copilot-input",
  aiCopilotSend: "ai-copilot-send",
};

export const DASHBOARD = {
  kpiCard: (key) => `kpi-${key}`,
  funnelChart: "funnel-chart",
  activityFeed: "activity-feed",
};

export const ATS = {
  kanbanColumn: (stage) => `kanban-col-${stage}`,
  kanbanCard: (id) => `kanban-card-${id}`,
  stageSelect: (id) => `stage-select-${id}`,
};

export const JOBS = {
  jobRow: (id) => `job-row-${id}`,
  newJobBtn: "new-job-btn",
  jobTitleInput: "job-title-input",
  jobClientInput: "job-client-input",
  jobLocationInput: "job-location-input",
  jobDescriptionInput: "job-description-input",
  jobSkillsInput: "job-skills-input",
  jobSubmit: "job-submit-btn",
  aiDraftJdBtn: "ai-draft-jd-btn",
};
